import React, { useState, useEffect } from "react";
import HireneuronConfig from "./HireneuronConfig";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  generateKey,
  verifyData,
} from "../../pages/Common/CommonFunctions/commonFunctions";
import moment from "moment";

/**
 * this component handle the hireneuron table search
 */
const HireneuronSearch = (props) => {
  const [filterValue, setFilterValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [getSuggestions, setGetSuggestions] = useState(false);
  const [selectOptions, setSelectOptions] = useState([]);
  const [filterType, setFilterType] = useState(null);
  const [filterButton, setFilterButton] = useState(false);
  const [showFilterConditions, setShowFilterConditions] = useState(false);
  const [filterConditions, setFilterConditions] = useState([]);
  const [filterCondition, setFilterCondition] = useState(null);

  useEffect(() => {
    if (props.column.actions != null && props.column.actions != undefined) {
      setFilterButton(props.column.actions);
    } else {
      let filter = props.column.filter;
      if (
        filter.suggestions != null &&
        filter.suggestions != undefined &&
        filter.suggestions
      ) {
        setGetSuggestions(true);
      }
      setSelectOptions(
        filter.givenOptions !== undefined && filter.givenOptions != null
          ? filter.givenOptions
          : filter.options !== undefined && filter.options != null
            ? filter.options
            : [],
      );
      setFilterType(
        filter.type == undefined || filter.type == null ? [] : filter.type,
      );
      let filterConditions1 =
        filter.filterConditions == undefined || filter.filterConditions == null
          ? []
          : filter.filterConditions;
      setFilterConditions(filterConditions1);
      if (props.filterValue == null || props.filterValue == undefined) {
        if (filterConditions1.length > 0) {
          setFilterCondition(filterConditions1[0].value);
        }
      } else {
        let fullFilterValue = props.filterValue;
        setFilterValue(fullFilterValue.split("[")[1].split("]")[0]);
        setFilterCondition(fullFilterValue.split("[")[0]);
      }
    }
  }, []);

  useEffect(() => {
    if (
      props.suggestionsFor == props.column.label &&
      props.suggestions != undefined &&
      props.suggestions != null
    ) {
      setSuggestions(props.suggestions);
    }
  }, [props.suggestions, props.suggestions]);

  useEffect(() => {
    if (props.filterValue != null && props.filterValue != undefined) {
      let filter = props.column.filter.type;
      if (filter == "date") {
        if (verifyData(props.filterValue)) {
          let fullFilterValue = decodeURIComponent(props.filterValue);
          setFilterValue(parseInt(fullFilterValue.split("[")[1].split("]")[0]));
        }
      } else {
        let fullFilterValue = decodeURIComponent(props.filterValue);
        setFilterValue(fullFilterValue.split("[")[1].split("]")[0]);
      }
    } else {
      setFilterValue("");
    }
  }, [props.filterValue]);

  const handleFilterValue = (value, getSuggestions1, type) => {
    if (type == "date") {
      setFilterValue(new Date(value).getTime());
      props.handleFilterValue(
        new Date(value).getTime(),
        filterCondition,
        getSuggestions1 == undefined ? getSuggestions : getSuggestions1,
      );
    } else {
      setFilterValue(value);
      props.handleFilterValue(
        value,
        filterCondition,
        getSuggestions1 == undefined ? getSuggestions : getSuggestions1,
      );
    }
  };

  const handleFilterCondition = (newCondition) => {
    setFilterCondition(newCondition);
    props.handleFilterValue(filterValue, newCondition, false);
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
      <select
        hidden={filterType !== HireneuronConfig.searchType.Select}
        className="form-select form-select-sm flex-grow-1"
        id={
          "as-filter-select-" +
          props.column.name.toLowerCase().replaceAll(" ", "-")
        }
        onChange={(e) => handleFilterValue(e.target.value, false, filterType)}
      >
        {selectOptions.map((option) => {
          return (
            <option
              key={generateKey()}
              value={option.value}
              selected={option.value == filterValue}
            >
              {option.label}
            </option>
          );
        })}
      </select>
      <select
        hidden={filterType !== HireneuronConfig.searchType.Dropdown}
        className="form-select form-select-sm flex-grow-1"
        id={
          "as-filter-dropdown-value-" +
          props.column.name.toLowerCase().replaceAll(" ", "-")
        }
        value={filterValue}
        onChange={(e) => handleFilterValue(e.target.value, false, filterType)}
      >
        <option value="">-- Select --</option>
        {selectOptions.map((option) => {
          return (
            <option key={generateKey()} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
      <input
        id={
          "as-filter-value-" +
          props.column.name.toLowerCase().replaceAll(" ", "-")
        }
        className="form-control form-control-sm flex-grow-1 test"
        value={
          filterType === "date"
            ? filterValue
              ? moment(filterValue).format("YYYY-MM-DD")
              : ""
            : filterValue
        }
        type={filterType}
        onChange={(e) => handleFilterValue(e.target.value, false, filterType)}
        hidden={
          filterType === null ||
          filterType === HireneuronConfig.searchType.Select ||
          filterType === HireneuronConfig.searchType.Dropdown
        }
      />

      <div
        className="dropdown-custom-suggestion-menu-outer-new"
        hidden={suggestions.length === 0 && verifyData(filterValue)}
      >
        <Dropdown
          isOpen={suggestions.length > 0}
          toggle={() => setSuggestions([])}
          id={
            "as-filter-suggestion-dropdown-" +
            props.column.name.toLowerCase().replaceAll(" ", "-")
          }
        >
          <DropdownToggle tag="button" className="d-none "></DropdownToggle>
        <DropdownMenu style={{ maxHeight: "200px", overflowY: "auto" }} className="table-action-menu">
          {suggestions.map((value) => {
            return (
              <DropdownItem
                key={generateKey()}
                onClick={() =>
                  handleFilterValue(value, getSuggestions, filterType)
                }
                value={value}
                className="table-action-menu-item"
              >
                {value}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
        </Dropdown>
      </div>
      <button
        hidden={!filterButton}
        disabled={props.disableFilterButton}
        id={filterButton ? "as-apply" : ""}
        className="btn btn-sm btn-success m-auto"
        type="button"
        onClick={() => props.handleApply()}
      >
        Apply
      </button>

      <Dropdown
        hidden={filterConditions.length == 0}
        isOpen={showFilterConditions}
        toggle={() => setShowFilterConditions(!showFilterConditions)}
        className=""
        id="as-filter-dropdown"
      >
        <DropdownToggle
          tag="button"
          className="btn btn-sm btn-filter custom-column-filter-btn"
          id={
            "as-filter-show-" +
            props.column.name.toLowerCase().replaceAll(" ", "-")
          }
        >
          <i className="fa fa-filter" />
        </DropdownToggle>
        <DropdownMenu className="filter-icon-menu table-action-menu" style={{ maxHeight: "200px", overflowY: "auto" }}>
          {filterConditions.map((option) => {
            return (
              <DropdownItem
                id={
                  "as-filter-dropdown-" +
                  props.column.name.toLowerCase().replaceAll(" ", "-") +
                  "-" +
                  option.label.toLowerCase().replaceAll(" ", "-")
                }
                key={generateKey()}
                className={
                  filterCondition === option.value
                    ? "filter-item active table-action-menu-item"
                    : "filter-item table-action-menu-item"
                }
                value={option.value}
                onClick={() => handleFilterCondition(option.value)}
              >
                {option.label}
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default HireneuronSearch;
